var angular = require('angular');
var GeoAPI = require('../../api').GeoMatch;
var _ = require('underscore')

module.exports = function ($scope, options) {

  $scope.selectedGeographicAreas = angular.copy(options.value) || [];
  // $scope.publicFullTree = public;
  // $scope.fullTree = private;

  $scope.defaultToPlaces = options.defaultToPlaces;

  $scope.cancel = function () {
    $scope.closeThisDialog({ action: 'cancel'});
  }

  $scope.save = function () {
    $scope.closeThisDialog({ action: 'save', value: $scope.selectedGeographicAreas });
  }
}
